import { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Box } from '@mui/material'
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import ProtectedRoute from './components/common/ProtectedRoute'
import Home from './pages/Home'
import About from './pages/About'
import Dashboard from './pages/Dashboard'
import AuthCallback from './pages/AuthCallback'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import NotFound from './pages/NotFound'
import { initGA, trackPageView } from './utils/analytics'

function App() {
  const location = useLocation()
  const isDashboard = location.pathname === '/dashboard'
  const isAuthCallback = location.pathname === '/authenticate'

  // Initialize Google Analytics (production only)
  useEffect(() => {
    initGA()
  }, [])

  // Track page views on route changes (production only)
  useEffect(() => {
    trackPageView(location.pathname + location.search)
  }, [location])

  // Dashboard has its own layout (no shared navbar/footer)
  if (isDashboard) {
    return (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    )
  }

  // OAuth callback page has no navbar/footer
  if (isAuthCallback) {
    return <AuthCallback />
  }

  // Regular pages with shared navbar/footer
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  )
}

export default App
